<template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="pt-10 d-flex flex-column w-auto">
      <div class="d-flex justify-center pb-3">
        <Logo :smallSize="true"/>
      </div>
      
      <h3 class="form-title pb-3" style="text-align: center">Reset password</h3>

      <v-row class="px-0 mx-0 w-100">
        <div class="px-0">
          <v-form
              ref="form"
              lazy-validation
              @submit.prevent="onSubmit"
              v-model="isFormValid"
          >
            <v-text-field
                name="email"
                v-model="email"
                :label="$t('ForgotPassword.EnterEmail')"
                :rules="rules.email"
                required
            ></v-text-field>
            <div v-show="isEmailSent">
              <p class="green--text body-2 py-3 form-hint">
                {{ $t('ForgotPassword.PasswordResetInstructionsWasSent') }}.
              </p>
            </div>
            <div v-show="!isEmailSent">
              <p class="body-2 py-3 form-hint">
                {{ $t('ForgotPassword.PasswordResetInstructionsWillBeSent') }}.
              </p>
              <div>
                <v-btn
                    type="submit"
                    color="primary"
                    block
                    class="mt-10"
                    :disabled="!isFormValid || isLoading"
                    :loading="isLoading"
                >
                  {{ $t('ForgotPassword.Send') }}
                </v-btn>
              </div>
            </div>
          </v-form>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/firestore";
import Logo from "../login/Logo.vue";
import {ValidationRules} from "@/utils/validation-rules";
import {Component, Vue} from "vue-property-decorator";
import {getRegionName} from "@/utils/functionsRegion";

@Component({
  components: {
    Logo
  }
})
export default class ForgotPassword extends Vue {
  email = "";
  isFormValid = true;
  isLoading = false;
  isEmailSent = false;
  screenWidth = window.innerWidth;

  get rules() {
    return {
      email: [ValidationRules.required, ValidationRules.email]
    };
  }

  get screenJustifyClass() {
    return this.screenWidth > 600 ? 'justify-content-center' : '';
  }

  async onSubmit() {
    this.isFormValid = this.$refs.form.validate();

    if (!this.isFormValid) return;

    this.isLoading = true;

    try {

      await firebase.app().functions(getRegionName()).httpsCallable("resetUserPasswordByEmail")({
        email: this.email
      }).then((data) => {
        const response = data;
        if (response.data.data.code === "Failed") {
          this.$toast.open({message: `${response.data.data.message}`, type: "error"});
        } else {
          this.isEmailSent = true;
        }
      }).catch(function (error) {
        this.$toast.open({message: `${error.message}`, type: "error"});
      });
    } catch (e) {
      console.error(e);
    }

    this.isLoading = false;
  }
}
</script>
